import React, { useState } from 'react';

import { Alert } from 'components/bootstrap';
import { HIDE_LAKE_ADD_TO_INVESTIGATION_HELP_TEXT_KEY } from 'data-lake/Constants';
import Store from 'logic/local-storage/Store';
import { Pluralize } from 'components/common';
import useSelectedEntities from 'components/common/EntityDataTable/hooks/useSelectedEntities';

const AddToInvestigationHelp = () => {
  const { selectedEntities } = useSelectedEntities();
  const [hideHelpText, setHideHelpText] = useState(Store.get(HIDE_LAKE_ADD_TO_INVESTIGATION_HELP_TEXT_KEY) === 'true');
  const hideHelp = () => {
    Store.set(HIDE_LAKE_ADD_TO_INVESTIGATION_HELP_TEXT_KEY, 'true');
    setHideHelpText(true);
  };

  return (
    <>
      <p>
        You are about to retrieve {selectedEntities?.length}{' '}
        <Pluralize singular="log" plural="logs" value={selectedEntities?.length} />.
      </p>
      {!hideHelpText && (
        <Alert bsStyle="info" onDismiss={hideHelp}>
          Messages added to an investigation will be retrieved first. Any message not yet stored in the{' '}
          <b>Search Cluster</b> will count towards your licence usage. Note that retrieving messages from the Data Lake
          may take some time.
        </Alert>
      )}
    </>
  );
};

export default AddToInvestigationHelp;
